export type AgentSseFrame = {
  event: string
  data: unknown
}

export function parseSseFrame(frame: string): AgentSseFrame | null {
  let event = "message"
  const dataLines: string[] = []

  for (const line of frame.split(/\r?\n/)) {
    if (!line || line.startsWith(":")) continue
    const colon = line.indexOf(":")
    const field = colon === -1 ? line : line.slice(0, colon)
    const rawValue = colon === -1 ? "" : line.slice(colon + 1)
    const value = rawValue.startsWith(" ") ? rawValue.slice(1) : rawValue

    if (field === "event") event = value
    if (field === "data") dataLines.push(value)
  }

  if (!dataLines.length) return null
  const rawData = dataLines.join("\n")
  try {
    return { event, data: JSON.parse(rawData) }
  } catch {
    return { event, data: rawData }
  }
}
